var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessDelivery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1.00006,
    width: 34,
    height: 34,
    rx: 17,
    fill: "white",
    stroke: "#003B6F"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_119_17914)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8015 6.88036C12.2938 6.65207 13.6984 7.52939 14.1889 8.89948H15.9951V10.4539H14.3175C14.1037 11.7407 13.0996 12.8064 11.7395 13.0148C10.0464 13.2738 8.46305 12.1107 8.20301 10.4168C7.94441 8.72286 9.10753 7.13941 10.8015 6.88036Z",
    fill: "#003B6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.4973 19.3724C22.4973 19.0902 22.7261 18.8611 23.0087 18.8611H25.223C25.5057 18.8611 25.7344 19.0902 25.7344 19.3724C25.7344 19.6541 25.5057 19.8838 25.223 19.8838H23.0087C22.7261 19.8838 22.4973 19.6542 22.4973 19.3724Z",
    fill: "#003B6F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0479 15.2603L17.5074 19.4639L19.0646 19.8494V16.2966H29.167V25.1559H19.0646V22.7173L17.6066 22.4822C16.9114 22.383 16.4009 22.2077 15.7881 21.8662L13.889 20.8725V25.1559H8.4571V16.6082C8.4571 13.8106 11.6116 13.8029 13.0479 15.2603ZM20.3078 23.9125H27.9237V17.5399H20.3078V20.1569L21.8015 20.5265C22.4565 20.7067 22.856 21.368 22.711 22.0316L22.6988 22.0827C22.5561 22.7354 21.9338 23.167 21.2721 23.0728L20.3078 22.9175V23.9125Z",
    fill: "#003B6F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_17914"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "matrix(-1 0 0 1 29.167 5.50006)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessDelivery);
export default __webpack_public_path__ + "static/media/SuccessDelivery.1acf825fb58c561f290f5ea21b962206.svg";
export { ForwardRef as ReactComponent };